import(/* webpackMode: "eager" */ "/home/ubuntu/download/69845926921dc90014acc87b/beautyskinclinic/src/app/gallery/page.tsx");
